import { createFileRoute } from '@tanstack/react-router';

import { EmailVerified } from 'src/apps/standalone/app/pages/EmailVerified';
import { createPageMetaTitle } from 'src/utils/createPageMetaTitle';

export const Route = createFileRoute('/_auth/(no-layout)/verified')({
  staticData: { title: createPageMetaTitle('Email verified') },
  component: () => <EmailVerified />,
});
